// extracted by mini-css-extract-plugin
export var footer = "_m0-0";
export var inherit = "_m0-1";
export var input = "_m0-2";
export var modalContent = "_m0-3";
export var quillEditor = "_m0-4";
export var subtitle = "_m0-5";